import "./App.css";
import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";


const CreateRecord = lazy(() => import("./components/CreateRecord"));
const RequiredAuth = lazy(() => import("./components/RequiredAuth"));
const PageNotFound = lazy(() => import("./components/PageNotFound"));
const Loginpage = lazy(() => import("./components/Loginpage"));
const TableViewPage = lazy(() => import("./components/TableViewPage"));
const Loading = lazy(() => import("./components/Loading"));

function App() {
  return (
    <React.Suspense fallback={<Loading />}>
      {/* <ToastContainer> */}
      <Routes>
        <Route index element={<Loginpage />} />

        <Route
          path="/tableview"
          element={
            <RequiredAuth>
              <TableViewPage />
            </RequiredAuth>
          }
        />

        <Route path="/create-record/*" element={<CreateRecord />} />
        {/* <Route path="/create-record/employee/*" element={<CreateRecord />} /> */}
        <Route path="/records/employee/:empid" element={<CreateRecord />} />
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
      {/* </ToastContainer> */}
    </React.Suspense>
  );
}

export default App;
